import SiteNav from '@/pages/home/components/SiteNav';
import HeroSection from '@/pages/home/components/HeroSection';
import MovieExplorer from '@/pages/home/components/MovieExplorer';
import HotRecommend from '@/pages/home/components/HotRecommend';
import DoubanTopList from '@/pages/home/components/DoubanTopList';
import WordOfMouth from '@/pages/home/components/WordOfMouth';
import MustWatchTimeline from '@/pages/home/components/MustWatchTimeline';
import RankingsTabs from '@/pages/home/components/RankingsTabs';
import FaqSection from '@/pages/home/components/FaqSection';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteNav />
      <main className="flex-1 w-full">
        <HeroSection />
        <MovieExplorer />
        <HotRecommend />
        <DoubanTopList />
        <WordOfMouth />
        <MustWatchTimeline />
        <RankingsTabs />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}